<template>
  <!-- 1. 第一组插槽：用于当前层级的菜单项 -->
  <component :is="menuComponent" v-if="!item.hidden" :item="item">
    <!-- 1.1 传递left插槽到MenuItem或Submenu组件 -->
    <template #left="slotProps">
      <slot name="left" v-bind="slotProps"></slot>
    </template>
    <!-- 1.2 传递dropdown插槽到MenuItem或Submenu组件 -->
    <template #right="slotProps">
      <slot name="right" v-bind="slotProps"></slot>
    </template>
    <!-- 2. 第二组插槽：用于子菜单项的递归 -->
    <template v-if="item.children && item.children.length">
      <menu-box v-for="route in item.children" :key="route.id" :item="route">
        <!-- 2.1 传递left插槽到子菜单项 -->
        <template #left="slotProps">
          <slot name="left" v-bind="slotProps"></slot>
        </template>
        <!-- 2.2 传递dropdown插槽到子菜单项 -->
        <template #right="slotProps">
          <slot name="right" v-bind="slotProps"></slot>
        </template>
      </menu-box>
    </template>
  </component>
</template>

<script>
  import MenuItem from './components/MenuItem'
  import Submenu from './components/Submenu'
  export default {
    name: 'menuBox',
    components: { MenuItem, Submenu },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        menuComponent: '',
      }
    },
    created() {
      const showChildren = this.handleChildren(this.item.children)
      if (showChildren.length === 0) {
        this.menuComponent = 'MenuItem'
      } else {
        this.menuComponent = 'Submenu'
      }
    },
    methods: {
      handleChildren(children = []) {
        if (children === null) return []
        return children.filter((item) => item.hidden !== true)
      },
      emitupdate() {
        this.$emit('emitupdate')
      },
    },
  }
</script>
<style lang="scss">
  /* 目录内容样式 */
  .ehf-sub-menu .catalog_item,
  .ehf-menu-item .catalog_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .catalog_center {
      display: flex;
      align-items: center;
      flex: 1;
      width: calc(100% - 60px);
      .catalog_title {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    /* 目录右侧...样式 */
    .catalog_right {
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }
    /* 省略号显隐 */
    .catalog_icon {
      display: none;
    }
    &:hover {
      .catalog_icon {
        display: block;
      }
    }
  }
  /* 目录父级头像样式 */
  .ehf-sub-menu .catalog_item,
  .ehf-menu-item .catalog_item {
    margin-right: 0px;
    .catalog_left {
      display: flex;
      .left_user_info {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 10px;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
</style>
